export enum ISegments {
  Family = "Family",
  Couples = "Couples",
  Generic = "Generic",
  HighSpenders = "High Spenders",
  LowSpenders = "Low Spenders",
  Pet = "Pet",
  Bike = "Bike",
  Alpine = "Alpine",
  Naturisti = "Naturisti",
}

